module.exports = __webpack_public_path__ + "static/media/office-day.6e9a7761.mp4";